"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionType = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const constant_1 = require("../../constant");
// 출제 유형 (기본)
const questionTypeList = [
    { id: 'select', title: 'common.select' },
    { id: 'OMR', title: 'assignment.OMR' },
    { id: 'OMR-free', title: 'assignment.OMR-free' },
    { id: 'attachment', title: 'assignment.attachment' },
    { id: 'survey', title: 'assignment.survey' },
];
// '설문조사'는 강의 등록(allowSurvey=true)에서만 선택 가능 — 다른 페이지에선 미노출
const surveyPollType = { id: 'survey-poll', title: 'assignment.survey-poll' };
/**
 * 출제 유형 선택 dropdown
 *  - 출제 유형 (OMR 기본형, OMR 자유형, 첨부파일, 설문형) 선택
 *  - 설문조사: 강의 등록에서만 노출(allowSurvey). 그 외 페이지에선 목록에 없음.
 */
exports.QuestionType = react_1.default.memo(({ questionType, setQuestionType, setSubject, isModify = false, allowSurvey = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    // 강의 등록에서만 '설문조사' 옵션 노출. (편집 등으로 이미 값이 survey-poll 이면 표시 유지)
    const list = allowSurvey || questionType?.id === 'survey-poll'
        ? [...questionTypeList, surveyPollType]
        : questionTypeList;
    return (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label" }, t('assignment.questionType')),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.DropDown, { className: 'dropdown-popup', value: questionType, styles: {
                    dropWrap: {
                        flex: 1,
                        // maxWidth: isDesktop ? '272px' : isMobile ? undefined : '184px',
                    },
                    titleWrap: {
                        padding: isMobile && '9px',
                    },
                }, list: list, setDropValue: value => {
                    setQuestionType(value);
                    setSubject(constant_1.default_subject);
                } }))));
});
